import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { MdFilterAlt } from "react-icons/md";
import { FcClearFilters } from "react-icons/fc";

import { useState } from "react";
export default function Filter({ filterFunction }) {
  // 0 => order
  // 1 => repair
  const [filterData, setFilterData] = useState({
    fname: "",
    lname: "",
    deliverName: "",
    type: "",
    main_status: "",
    mtm_from: "",
    mtm_to: "",
    send_trackingcode: "",
    order_code: "",
    mobile: "",
  });
  const changeHandler = (value, type) => {
    setFilterData((prev) => {
      return { ...prev, [type]: value };
    });
  };

  return (
    <div className=" d-flex order-item2 mx-4 mt-5 p-4">
      <div>
        <form className="form row w-100">
          <div className=" container-responsive2 col-12 col-md-6 col-lg-4 d-flex align-items-center mt-2 ">
            <div className="label" style={{ width: "50%" }}>
              <label
                htmlFor="nameUser"
                style={{
                  color: "#707070",
                  whiteSpace: "nowrap",
                  fontSize: "14px",
                }}
              >
                نام :
              </label>
            </div>
            <div className="input" style={{ width: "50%" }}>
              <input
                type="text"
                // required
                className="form-control"
                id="nameUser"
                name="fName"
                value={filterData.fname}
                onChange={(e) => {
                  changeHandler(e.target.value, "fname");
                }}
              />
            </div>
          </div>
          <div className=" container-responsive2 col-12 col-md-6 col-lg-4 d-flex align-items-center mt-2 ">
            <div className="label" style={{ width: "50%" }}>
              <label
                htmlFor="deliverName"
                style={{
                  color: "#707070",
                  whiteSpace: "nowrap",
                  fontSize: "15px",
                }}
              >
                نام خانوادگی :
              </label>
            </div>
            <div className="input" style={{ width: "50%" }}>
              <input
                type="text"
                // required
                className="form-control"
                id="deliverName"
                name="fName"
                value={filterData.lname}
                onChange={(e) => {
                  changeHandler(e.target.value, "lname");
                }}
              />
            </div>
          </div>
          <div className=" container-responsive2 col-12 col-md-6 col-lg-4 d-flex align-items-center mt-2">
            <div className="label" style={{ width: "50%" }}>
              <label
                htmlFor="DateReceived"
                style={{ color: "#707070", whiteSpace: "nowrap" }}
              >
                تاریخ دریافت از :
              </label>
            </div>
            <div className="input" style={{ width: "50%" }}>
              <div style={{ direction: "rtl" }}>
                <DatePicker
                  calendar={persian}
                  locale={persian_fa}
                  inputClass={"date-picker-style form-control"}
                  calendarPosition="bottom-right"
                  id="DateReceived"
                  name="DateReceived"
                  value={filterData.mtm_from}
                  onChange={(value) => {
                    changeHandler(value, "mtm_from");
                  }}
                />
              </div>
            </div>
          </div>
          <div className=" container-responsive2 col-12 col-md-6 col-lg-4 d-flex align-items-center mt-2">
            <div className="label" style={{ width: "50%" }}>
              <label
                htmlFor="upTo"
                style={{ color: "#707070", whiteSpace: "nowrap" }}
              >
                تاریخ دریافت تا:
              </label>
            </div>
            <div className="input" style={{ width: "50%" }}>
              <div style={{ direction: "rtl" }}>
                <DatePicker
                  calendar={persian}
                  locale={persian_fa}
                  inputClass={"date-picker-style form-control"}
                  calendarPosition="bottom-right"
                  id="upTo"
                  name="upTo"
                  value={filterData.mtm_to}
                  onChange={(value) => {
                    changeHandler(value, "mtm_to");
                  }}
                />
              </div>
            </div>
          </div>
          <div className=" container-responsive2 col-12 col-md-6 col-lg-4 d-flex align-items-center mt-2">
            <div className="label" style={{ width: "50%" }}>
              <label
                htmlFor="type"
                style={{ color: "#707070", whiteSpace: "nowrap" }}
              >
                نوع :
              </label>
            </div>
            <div className="input" style={{ width: "50%" }}>
              <select
                id="type"
                name="type"
                className="form-control form-select"
                value={filterData.type}
                onChange={(e) => {
                  setFilterData((prev) => {
                    return { ...prev, type: e.target.value };
                  });
                }}
              >
                <option value={0}>سفارش</option>
                <option value={1}> تعمیر</option>
              </select>
            </div>
          </div>
          <div className=" container-responsive2 col-12 col-md-6 col-lg-4 d-flex align-items-center mt-2">
            <div className="label" style={{ width: "50%" }}>
              <label
                htmlFor="status"
                style={{ color: "#707070", whiteSpace: "nowrap" }}
              >
                وضعیت :
              </label>
            </div>
            <div className="input" id="status" style={{ width: "50%" }}>
              <select
                id="status"
                name="status"
                className="form-control form-select"
                value={filterData.main_status}
                onChange={(e) => {
                  changeHandler(e.target.value, "main_status");
                }}
              >
                <option value="0">ثبت شده</option>
                <option value="1"> تکمیل شده</option>
                <option value="2">لغو شده</option>
                {/* <option value={3}>درحال تست</option> */}
              </select>

              {/* {filterData.type == 0 ? (
                <select
                  id="status"
                  name="status"
                  className="form-control form-select"
                  value={filterData.status}
                  onChange={e => {
                    changeHandler(e.target.value, "status");
                  }}
                >
                  <option value={0}>ثبت شده</option>
                  <option value={1}> پرداخت شده</option>
                  <option value={2}>پردازش شده </option>
                  <option value={3}>ارسال شده </option>
                </select>
              ) : (
                <select
                  id="status"
                  name="status"
                  className="form-control form-select"
                  value={filterData.status}
                  onChange={e => {
                    changeHandler(e.target.value, "status");
                  }}
                >
                 
                  <option value={0}>دریافت کالا ودر انتظار برسی</option>
                  <option value={1}> درحال برسی</option>
                  <option value={2}>در حال تعمیر</option>
                  <option value={3}>درحال تست</option>
                  <option value={4}>اماده ی تحویل</option>
                </select>
              )} */}
            </div>
          </div>
          <div className=" container-responsive2 col-12 col-md-6 col-lg-4 d-flex align-items-center mt-2">
            <div className="label" style={{ width: "50%" }}>
              <label
                htmlFor="tracking"
                style={{ color: "#707070", whiteSpace: "nowrap" }}
              >
                شماره پیگیری :
              </label>
            </div>
            <div className="input" style={{ width: "50%" }}>
              <input
                type="text"
                name="tracking"
                // required
                className="form-control"
                id="tracking"
                value={filterData.send_trackingcode}
                onChange={(e) => {
                  // if (!isNaN(e.target.value))
                  changeHandler(e.target.value, "send_trackingcode");
                }}
              />
            </div>
          </div>
          <div className=" container-responsive2 col-12 col-md-6 col-lg-4 d-flex align-items-center mt-2">
            <div className="label" style={{ width: "50%" }}>
              <label
                htmlFor="orderNumber"
                style={{ color: "#707070", whiteSpace: "nowrap" }}
              >
                شماره سفارش :
              </label>
            </div>
            <div className="input" style={{ width: "50%" }}>
              <input
                type="text"
                // required
                className="form-control"
                id="orderNumber"
                name="orderNumber"
                value={filterData.order_code}
                onChange={(e) => {
                  if (!isNaN(e.target.value))
                    changeHandler(e.target.value, "order_code");
                }}
              />
            </div>
          </div>
          <div className=" container-responsive2 col-12 col-md-6 col-lg-4 d-flex align-items-center mt-2">
            <div className="label" style={{ width: "50%" }}>
              <label
                htmlFor="numberM"
                style={{ color: "#707070", whiteSpace: "nowrap" }}
              >
                موبایل :
              </label>
            </div>
            <div className="input" style={{ width: "50%" }}>
              <input
                type="text"
                // required
                className="form-control"
                id="numberM"
                name="numberM"
                value={filterData.mobile}
                onChange={(e) => {
                  if (!isNaN(e.target.value))
                    changeHandler(e.target.value, "mobile");
                }}
              />
            </div>
          </div>
          <div className="box-btn col-12 d-flex align-items-center justify-content-end mt-3">
            <div className="btn">
              <button
                style={{
                  marginLeft: "5px",

                  backgroundColor: "#457b9d",
                  color: "white",
                  border: "none",
                  borderRadius: "15px",
                  padding: "8px 20px ",
                  fontSize: "18px",
                }}
                type="button"
                onClick={() => {
                  return filterFunction(
                    // filterData,
                    {
                      ...filterData,
                      mtm_from: filterData.mtm_from && filterData.mtm_from.unix,

                      mtm_to: filterData.mtm_to && filterData.mtm_to.unix,
                    },
                    "1"
                  );
                }}
              >
                فیلتر
                <MdFilterAlt></MdFilterAlt>
              </button>
            </div>
            <div className="btn">
              <button
                className="bg-danger"
                style={{
                  marginLeft: "10px",
                  color: "white",
                  border: "none",
                  borderRadius: "20px",
                  padding: "8px 20px ",
                  fontSize: "18px",
                }}
                type="button"
                onClick={() => {
                  filterFunction(filterData, "0");
                  setFilterData((prev) => {
                    return {
                      ...prev,
                      fname: "",
                      lname: "",
                      mtm_from: "",
                      mtm_to: "",
                      send_trackingcode: "",
                      order_code: "",
                      mobile: "",
                    };
                  });
                }}
              >
                حذف فیلتر
                <MdFilterAlt></MdFilterAlt>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
